<template>
  <footer class="bg-dark text-muted">
    <!-- Newsletter Section -->
    <section class="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-3 gap-lg-0 p-4 border-bottom bg-primary text-white">
      <div class="fw-bold">Stay Updated!</div>
      <form class="d-flex flex-grow-1 flex-shrink-1" style="max-width: 600px;" @submit.prevent="subscribe">
        <input
          type="email"
          class="form-control me-2 border-0 rounded-0"
          placeholder="Your Email"
          aria-label="Email"
          v-model="email"
          required
        />
        <button class="btn btn-dark" type="submit" :disabled="loading">
          {{ loading ? 'Signing Up...' : 'Sign Up' }}
        </button>
      </form>
      <div v-if="message" class="mt-2 ms-lg-3 w-100 w-lg-auto text-start">
        <span :class="success ? 'text-success' : 'text-danger'">{{ message }}</span>
      </div>
    </section>

    <!-- Footer Content -->
    <section class="pt-5 nf-footer-body">
      <div class="container-fluid px-4">
        <div class="row g-4 text-start">
          <!-- About Column -->
          <div class="col-xl col-lg-3 col-md-6 col-12">
            <div class="d-flex align-items-center mb-3">
              <img src="@/assets/nexus logo.jpg" alt="Nexus Logo" style="height: 40px;" class="me-2" />
              <h6 class="text-uppercase fw-bold text-primary mb-0">Nexus Focus Consultancy</h6>
            </div>
            <p class="text-light">
              Nexus Focus Consultancy empowers communities and institutions to address climate resilience, sustainability, and environmental justice.
              <router-link to="/about" class="text-primary">Read More</router-link>
            </p>
          </div>

          <!-- Quick Links Column -->
          <div class="col-xl col-lg-3 col-md-6 col-12">
            <h6 class="text-uppercase fw-bold text-primary mb-4">Quick Links</h6>
            <router-link to="/" class="text-white d-block mb-2">
              <i class="fas fa-angle-right text-primary me-2"></i>Home
            </router-link>
            <router-link to="/about" class="text-white d-block mb-2">
              <i class="fas fa-angle-right text-primary me-2"></i>About Us
            </router-link>
            <router-link to="/services" class="text-white d-block mb-2">
              <i class="fas fa-angle-right text-primary me-2"></i>Our Services
            </router-link>
            <router-link to="/blog" class="text-white d-block mb-2">
              <i class="fas fa-angle-right text-primary me-2"></i>Latest Blog Post
            </router-link>
            <router-link to="/contact" class="text-white d-block">
              <i class="fas fa-angle-right text-primary me-2"></i>Contact Us
            </router-link>
          </div>

          <!-- Offices Columns -->
          <div
            v-for="office in offices"
            :key="office.id"
            class="col-xl col-lg-3 col-md-6 col-12"
          >
            <h6 class="text-uppercase fw-bold text-primary mb-4">{{ office.office_name }}</h6>
            <div class="text-white d-flex flex-column contact-link">
              <div class="pb-3 text-light border-bottom border-primary">
                <i class="fas fa-map-marker-alt text-primary me-2"></i>{{ office.address }}
              </div>
              <div class="py-3 text-light border-bottom border-primary">
                <i class="fas fa-phone-alt text-primary me-2"></i>{{ office.phone }}
              </div>
              <div class="py-3 text-light border-bottom border-primary">
                <i class="fas fa-envelope text-primary me-2"></i>{{ office.email }}
              </div>
            </div>
          </div>

          <!-- Social Media Column (Last Column) -->
          <div class="col-xl col-lg-3 col-md-6 col-12">
            <h6 class="text-uppercase fw-bold text-primary mb-4">Follow Us</h6>
            <div class="d-flex gap-2">
              <a href="https://x.com/nexusfocusk?s=11" class="btn btn-lg-square rounded-circle" style="background-color: #1DA1F2;">
                <i class="fab fa-twitter text-white"></i>
              </a>
              <a href="https://www.facebook.com/share/1AnDoPy6qh/" class="btn btn-lg-square rounded-circle" style="background-color: #1877F2;">
                <i class="fab fa-facebook-f text-white"></i>
              </a>
              <!--<a href="#" class="btn btn-lg-square rounded-circle" style="background-color: #E4405F;">
                <i class="fab fa-instagram text-white"></i>
              </a>-->
              <a href="https://www.linkedin.com/in/nexus-focus-consultancy/" class="btn btn-lg-square rounded-circle" style="background-color: #0A66C2;">
                <i class="fab fa-linkedin-in text-white"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Copyright -->
    <section class="nf-footer-bottom py-4 px-4">
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
        <span class="text-white-50 small">
          &copy; {{ currentYear }} Nexus Focus Consultancy. All rights reserved.
        </span>
        <span class="text-white-50 small">
          Developed by <a href="https://maganatti.com" class="nf-footer-dev-link">Maganatti Tech Solution</a>
        </span>
      </div>
    </section>

    <!-- Back to Top -->
    <a href="#" class="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top">
      <i class="bi bi-arrow-up"></i>
    </a>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      email: "",
      message: "",
      success: false,
      loading: false,
      currentYear: new Date().getFullYear(),
      offices: [],
    };
  },
  mounted() {
    this.fetchOffices();
  },
  methods: {
    async fetchOffices() {
      try {
        const res = await fetch('https://admin.nexusfocusconsultancy.com/contact/api/offices/');
        const data = await res.json();
        this.offices = data;
      } catch (err) {
        console.error('Failed to load offices:', err);
      }
    },
    async subscribe() {
      this.message = "";
      this.success = false;
      this.loading = true;
      try {
        const response = await fetch("https://admin.nexusfocusconsultancy.com/subscriber/api/subscriber/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: this.email }),
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || "Subscription failed.");
        }
        this.message = "Thank you for subscribing!";
        this.success = true;
        this.email = "";
      } catch (error) {
        this.message = error.message || "Something went wrong.";
        this.success = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
footer { background: var(--nf-dark, #111c22) !important; }

/* Newsletter band */
footer > section:first-child {
  background: linear-gradient(135deg, var(--nf-green-dark, #0e4530), var(--nf-green, #1a6b4a)) !important;
}

.nf-footer-body { background: var(--nf-dark, #111c22); }

/* Link styles */
.nf-footer-body .text-white,
.nf-footer-body .text-light { transition: color .2s; }
.nf-footer-body .text-white:hover,
.nf-footer-body router-link:hover { color: var(--nf-gold, #c9992d) !important; }

.contact-link a {
  text-decoration: none;
  display: flex;
  align-items: center;
}
.contact-link a:hover { color: var(--nf-gold, #c9992d) !important; }

/* Bottom bar */
.nf-footer-bottom {
  background: rgba(0,0,0,0.3);
  border-top: 1px solid rgba(255,255,255,0.07);
}
.nf-footer-dev-link {
  color: var(--nf-gold, #c9992d);
  text-decoration: none;
  transition: opacity .2s;
}
.nf-footer-dev-link:hover { opacity: .75; }

/* Social buttons */
.btn-lg-square {
  width: 42px; height: 42px;
  padding: 0; text-align: center; line-height: 42px;
  transition: transform .2s, box-shadow .2s;
  border-radius: 50% !important;
}
.btn-lg-square:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.3);
}

/* footer primary colour override */
footer .text-primary { color: var(--nf-gold, #c9992d) !important; }
footer .border-primary { border-color: rgba(255,255,255,0.1) !important; }

.border-top { border-top: 1px solid rgba(255,255,255,0.08) !important; }

@media (max-width:767px) {
  .back-to-top { right:15px; bottom:15px; }
}
</style>
